import { createClient } from "next-sanity";
import { sanityDataset, sanityDotComDataset, sanityProjectId } from "./env";

/**
 * Default Sanity client with CDN enabled.
 * Use this for client-side fetching or highly dynamic SSR content.
 */
export const sanityClient = createClient({
  projectId: sanityProjectId,
  dataset: sanityDataset,
  apiVersion: "2026-09-07",
  useCdn: true,
  stega: {
    studioUrl: process.env.NEXT_PUBLIC_SANITY_STUDIO_PREVIEW_URL
  }
});

export const dotcomSanityClient = sanityClient.withConfig({
  dataset: sanityDotComDataset
});

/**
 * Client with CDN disabled for static generation, ISR, and tag-based revalidation.
 * This should be used with defineLive() for server-side data fetching.
 */
export const noCdnClient = sanityClient.withConfig({ useCdn: false });
